import axios from 'axios';
import { commRequest } from './axiosFun';

/**
 * 上下游管理
 **/
// 应用管理-获取应用管理列表
export const appList = (params) => { return commRequest("get", "/appinfo/list", params) };
export const appListTotal = () => {
    let parameter  = { 'pagesize': '0' }
    let platParamValueList = []
    appList(parameter).then(res => {
        if (res.statusCode == 200) {
            res.data.datas.forEach(item => {
                platParamValueList.push({
                    value: item.app_name,
                    id: item.app_id
                })
            });
        }
    })
    return platParamValueList
};
// 应用管理-获取应用信息（编辑）
export const appInfo = (params) => { return commRequest("get","/appinfo/updateget", params) };
// 应用管理-编辑保存应用
export const appSave = (params) => { return commRequest("post", "/appinfo/addorupdate", params) };
// 渠道管理-获取渠道管理列表
export const channelList = (params) => { return commRequest("get", "/channelinfo/list", params) };
export const channelListTotal = () => {
    let parameter  = { 'pagesize': '0' }
    let channelListArr = []
    channelList(parameter).then(res => {
        if (res.statusCode == 200) {
            res.data.datas.forEach(item => {
                channelListArr.push({
                    value: item.channel_name,
                    id: item.channel_id
                })
            });
        }
    })
    return channelListArr
};
// 渠道管理-获取渠道信息（编辑）
export const channelInfo = (params) => { return commRequest("get","/channelinfo/updateget", params) };
// 渠道管理-编辑保存渠道
export const channelSave = (params) => { return commRequest("post", "/channelinfo/addorupdate", params) };
// 接口配置-获取接口排重配置
export const appApiDist = (params) => { return commRequest("get","/appapiinfo/distinctget", params) };
// 接口配置-更新接口排重配置
export const appApiDistSave = (params) => { return commRequest("post", "/appapiinfo/distinctupdate", params) };
// 接口配置-获取接口点击配置
export const appApiClick = (params) => { return commRequest("get","/appapiinfo/clickget", params) };
// 接口配置-更新接口点击配置
export const appApiClickSave = (params) => { return commRequest("post", "/appapiinfo/clickupdate", params) };
// 接口配置-获取接口激活配置
export const appApiActiv = (params) => { return commRequest("get","/appapiinfo/activateget", params) };
// 接口配置-更新接口激活配置
export const appApiActivSave = (params) => { return commRequest("post", "/appapiinfo/activateupdate", params) };


/**
 * 投放管理 
 **/
// 投放计划-获取投放管理列表
export const putonplanList = (params) => { return commRequest("get", "/putonplaninfo/list", params) };
// 投放计划-获取应用信息（编辑）
export const putonplanInfo = (params) => { return commRequest("get","/putonplaninfo/updateget", params) };
// 投放计划-编辑保存应用
export const putonplanSave = (params) => { return commRequest("post", "/putonplaninfo/addorupdate", params) };
// 投放明细-获取投放管理列表
export const putonList = (params) => { return commRequest("get", "/putoninfo/list", params) };
// 投放明细-获取应用信息（编辑）
export const putonInfo = (params) => { return commRequest("get","/putoninfo/updateget", params) };
// 投放明细-编辑保存应用
export const putonSave = (params) => { return commRequest("post", "/putoninfo/addorupdate", params) };

/**
 * 数据报表 
 **/
// 日报统计-获取日报统计列表
export const dailyreportList = (params) => { return commRequest("get", "/dailyreport/list", params) };

/**
 * 请求明细 
 **/
// 排重记录-获取排重记录列表
export const distinctrequestList = (params) => { return commRequest("get", "/distinctrequest/list", params) };
// 数据明细-获取数据明细列表
export const detailrequestList = (params) => { return commRequest("get", "/detailrequest/list", params) };


// WEBPACK FOOTER //
// ./src/api/basisMG.js